import { Lock } from 'lucide-react'
import { Card } from '@/components/ui/card'

export const AccessDeniedFallback = () => (
  <Card>
    <div className="flex flex-col items-center justify-center py-24">
      <div className="mx-auto size-24 rounded-full bg-linear-to-b from-destructive/10 to-transparent flex items-center justify-center">
        <div className="size-14 bg-background flex items-center justify-center rounded-full border border-destructive/10 shadow-xs shadow-destructive/5">
          <Lock className="size-6 text-destructive" />
        </div>
      </div>
      <h1 className="mt-4 text-2xl font-display text-center">Access denied</h1>
      <p className="text-center text-muted-foreground">
        You do not have permission to view this page.
      </p>
    </div>
  </Card>
)
